module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic content center aligned segment"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreating),
      expression: "!isCreating"
    }],
    staticClass: "ui basic button icon",
    on: {
      "click": _vm.openForm
    }
  }, [_c('i', {
    staticClass: "plus icon"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreating),
      expression: "isCreating"
    }],
    staticClass: "ui centered card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleText),
      expression: "titleText"
    }],
    ref: "title",
    attrs: {
      "type": "text",
      "defaultValue": ""
    },
    domProps: {
      "value": (_vm.titleText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectText),
      expression: "projectText"
    }],
    ref: "project",
    attrs: {
      "type": "text",
      "defaultValue": ""
    },
    domProps: {
      "value": (_vm.projectText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two button attached buttons"
  }, [_c('button', {
    staticClass: "ui basic blue button",
    on: {
      "click": function($event) {
        _vm.sendForm()
      }
    }
  }, [_vm._v("\n            Create\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic red button",
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0db0f3a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateTodo.vue
// module id = 437
// module chunks = 1